"use strict";

function NotFoundError(message) {
  this.name = "Not found";
  this.message = message || "Not found";
  this.status = 404;
}

NotFoundError.prototype = Error.prototype;

module.exports = NotFoundError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/errors/notFound.js
 ** module id = 472
 ** module chunks = 0
 **/